import { HOST } from '../config';
import { IntersectionId } from '../types/primitives';
import { DayOfWeek } from '../types/DayOfWeek';

export const getIntersectionURL = (): string => `${HOST}/intersection`;

export const getAggDataURL = (startDate: string, endDate: string,
  intersections: IntersectionId[], selectedDaysOfWeek: DayOfWeek[],
  todStart: string, todEnd: string): string => {
  const dowString = selectedDaysOfWeek.map((d) => d.value)
    .join(',');
  return `${HOST}/agg_data/${startDate}/${endDate}/${intersections.join(',')}/${dowString}/${todStart}/${todEnd}`;
};

export const getPPDDataURL = (startDate: string, endDate: string,
  intersectionId: IntersectionId, selectedDaysOfWeek: DayOfWeek[],
  todStart: string, todEnd: string): string => {
  const dowString = selectedDaysOfWeek.map((d) => d.value)
    .join(',');
  return `${HOST}/ppd_data/${startDate}/${endDate}/${intersectionId}/${dowString}/${todStart}/${todEnd}`;
};

export const getRawPointsURL = (startDate: string, endDate: string,
  selectedDaysOfWeek: DayOfWeek[],
  todStart: string, todEnd: string, lat: number, long: number): string => {
  const dowString = selectedDaysOfWeek.map((d) => d.value)
    .join(',');
  return `${HOST}/raw_points/${startDate}/${endDate}/${dowString}/${todStart}/${todEnd}/${lat}/${long}`;
};
